import GeoJsonGeometriesLookup from "geojson-geometries-lookup"

export const format_thousands = (tick) => {
  if (tick >= 1000000) return `${tick / 1000000}M`
  if (tick >= 1000) return `${tick / 1000}k`
  if (tick <= -1000) return `${tick / 1000}k`
  if (tick <= -1000000) return `${tick / 1000}M`
  return tick
}

export function round_with_spaces(x) {
  return Math.round(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

export function get_stats_from_json(json_file, property_name) {
  const values = json_file.features
    .map((f) => f.properties[property_name])
    .filter((val) => typeof val === "number" && val > 0)

  if (values.length === 0) {
    console.log(`No numeric values found for property '${property_name}'.`)
    return null
  }

  const sum = values.reduce((acc, val) => acc + val, 0)
  const mean = sum / values.length
  const min = Math.min(...values)
  const max = Math.max(...values)

  return { mean, min, max }
}

export function calc_card_stats(geojson, mode, id) {
  if (!geojson || !mode || id == null) {
    return null
  }
  const result = {
    served: 0,
    unserved: 0,
    insured: 0,
    uninsured: 0,
    population: 0,
  }

  let id_property = mode === "districts" ? "district_id" : "cup_id"

  geojson.features.forEach(({ properties }) => {
    if (properties[id_property] === id) {
      result.served += properties.served || 0
      result.unserved += properties.unserved || 0
      result.insured += properties.insured || 0
      result.uninsured += properties.uninsured || 0
      result.population += properties.population || 0
    }
  })

  return result
}

export function calc_card_demographics(geojson, mode, id) {
  if (!geojson || !mode || id == null) {
    return null
  }
  const result = {
    sex: { male: 0, female: 0 },
    age: { "0_14": 0, "15_24": 0, "25_44": 0, "45_64": 0, "65_plus": 0 },
  }

  let id_property = mode === "districts" ? "district_id" : "cup_id"

  geojson.features.forEach(({ properties }) => {
    if (properties[id_property] === id) {
      // Sex
      result.sex.male += properties.male || 0
      result.sex.female += properties.female || 0
      // Age
      result.age["0_14"] += properties.age_0_4 || 0
      result.age["0_14"] += properties.age_5_9 || 0
      result.age["0_14"] += properties.age_10_14 || 0
      result.age["15_24"] += properties.age_15_19 || 0
      result.age["15_24"] += properties.age_20_24 || 0
      result.age["25_44"] += properties.age_25_29 || 0
      result.age["25_44"] += properties.age_30_34 || 0
      result.age["25_44"] += properties.age_35_39 || 0
      result.age["25_44"] += properties.age_40_44 || 0
      result.age["45_64"] += properties.age_45_49 || 0
      result.age["45_64"] += properties.age_50_54 || 0
      result.age["45_64"] += properties.age_55_59 || 0
      result.age["45_64"] += properties.age_60_64 || 0
      result.age["65_plus"] += properties.age_65_69 || 0
      result.age["65_plus"] += properties.age_70_74 || 0
      result.age["65_plus"] += properties.age_75_79 || 0
      result.age["65_plus"] += properties.age_80_above || 0
    }
  })

  return result
}

export const do_geometry_lookup = (
  geo_json,
  boundary_geojson,
  container_property_name,
  output_property_name = container_property_name,
  is_cups,
) => {
  const glookup = new GeoJsonGeometriesLookup(boundary_geojson)
  if (!geo_json || !geo_json.features || geo_json.features.length === 0)
    return []

  const matched = geo_json.features
    .filter((feature) => feature?.geometry)
    .map((feature) => {
      const containers = glookup.getContainers(feature.geometry)
      const container_value =
        containers.features[0]?.properties?.[container_property_name]

      const name = is_cups
        ? feature.properties?.referral_point
        : feature.properties?.name

      return {
        name,
        [output_property_name]:
          container_value !== undefined && container_value !== null
            ? isNaN(container_value)
              ? container_value
              : parseInt(container_value, 10)
            : null,
      }
    })

  return matched
}

const geometry_lookup = (boundary_feature, points_geo_json) => {
  if (!boundary_feature || !points_geo_json) return []
  const glookup = new GeoJsonGeometriesLookup(boundary_feature)
  const points_in_boundary = {}
  points_geo_json.features
    .filter((feature) => feature?.geometry)
    .forEach((feature) => {
      const result = glookup.getContainers(feature.geometry)
      if (result.features.length > 0) {
        const { type, name } = feature.properties
        if (!(type in points_in_boundary)) {
          points_in_boundary[type] = []
        }
        points_in_boundary[type].push(name)
      }
    })

  return points_in_boundary
}

export const calc_card_facilities = ({
  fac_geo_json,
  district_geo_json,
  cup_boundary_geo_json,
  mode,
  current_id,
}) => {
  if (!district_geo_json || !mode || current_id == null) {
    return null
  }
  const boundary = mode === "cups" ? cup_boundary_geo_json : district_geo_json
  if (!boundary) {
    return null
  }

  const filtered_boundary = {
    type: "FeatureCollection",
    features: boundary.features.filter((feature) => feature.id === current_id),
  }

  if (!filtered_boundary) {
    return null
  }
  const facilities = geometry_lookup(filtered_boundary, fac_geo_json)

  return facilities
}

export function get_facility_type(facility_name, facility_lookup) {
  for (const [type, facilities] of Object.entries(facility_lookup)) {
    if (facilities.some((f) => f.name === facility_name)) {
      return type
    }
  }
  return null
}
